import * as types from '../mutation-types';
import Vue from 'vue';
/* eslint-disable indent */
const stateData = {
          step:     {
              id:    1,
              text:  '',
              title: ''
          },
          finished: false
      },
      getters   = {
          step: s => s.step
      },
      actions   = {
          setStep({ commit }, id) {
              commit(types.SET_STEP, id);
          }
      },
      mutations = {
          [types.SET_STEP](state, id) {
              state.step = {
                  id:    id,
                  text:  Vue.i18n.translate(`TUTORIAL_STEP${id}_TEXT`),
                  title: Vue.i18n.translate(`TUTORIAL_STEP${id}_TITLE`)
              };
          },
          [types.FINISH_TUTORIAL](state) {
              state.finished = true;
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
